import { hasTrailingSlash, trimLeadingSlash } from './utils/index';

interface BuildCanonicalUrl {
  host: string;
  pathname?: string | null;
}

/**
 * Builds a URL string from the hostname and pathname.
 * It checks cases to avoid missing or doubling '/' symbol.
 */
export function buildCanonicalUrl({ host, pathname }: BuildCanonicalUrl): string {
  let pageUrl = host;

  if (pathname && pathname.length > 0) {
    // remove leading slash in pathname if it exist
    const cleanPath = trimLeadingSlash(pathname);
    if (!hasTrailingSlash(pageUrl)) pageUrl += '/';
    pageUrl += cleanPath;
  }

  return pageUrl;
}
